import React, { FC, ReactNode } from 'react';

import { Button } from '../Button/Button';

type DialogFooterPropsType = {
  submitCaption: ReactNode;
  secondarySubmitCaption?: ReactNode;
  confirmButtonType?: 'primary' | 'destructive';
  handleSubmitType?: (p: string) => void;
  cancelCallback?: (p: unknown) => void;
  cancelCaption?: ReactNode;
  cancelButtonVariant?: 'link' | 'outline' | 'destructive-outline';
  justifyContentStyle?: 'flex-end' | 'space-around' | 'space-between' | 'center' | 'flex-start';
  disabled?: boolean;
};
const DialogFooter: FC<DialogFooterPropsType> = ({
  submitCaption,
  confirmButtonType = 'primary',
  secondarySubmitCaption,
  handleSubmitType,
  cancelCallback,
  cancelCaption = 'Annuleren',
  cancelButtonVariant = 'link',
  justifyContentStyle = 'flex-end',
  disabled = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        marginTop: '20px',
        marginBottom: '4px',
        justifyContent: justifyContentStyle,
        gap: '12px',
      }}
    >
      {cancelCaption && cancelCallback && (
        <Button onClick={cancelCallback} variant={cancelButtonVariant}>
          {cancelCaption}
        </Button>
      )}
      <div style={{ display: 'flex', gap: '12px' }}>
        {secondarySubmitCaption && (
          <Button
            onClick={() => handleSubmitType?.('secondarySubmit')}
            type='submit'
            variant='outline'
            data-testid='dialogSecondarySubmitButton'
          >
            {secondarySubmitCaption}
          </Button>
        )}
        <Button
          type='submit'
          onClick={() => handleSubmitType?.('submit')}
          variant={confirmButtonType}
          data-testid='dialogSubmitButton'
          disabled={disabled}
        >
          {submitCaption}
        </Button>
      </div>
    </div>
  );
};
export default DialogFooter;
